module.exports = __webpack_public_path__ + "static/media/mobileapp.8cdb7193.png";